module.exports = __webpack_public_path__ + "static/media/DownloadIcon.05ff455b.svg";